@if (isRecorded()) {
  <onyx-message intent="information">
    <onyx-icon name="tooltip-filled" [size]="20"></onyx-icon>

    {{ `${I18N}.completedSwapHeading` | translate }}

    <span description>
      {{ `${I18N}.completedSwapDescription` | translate }}
    </span>
  </onyx-message>
} @else {
  @if (technicalPoints().at(0); as point) {
    <app-swap-modal-driver-report-item
      [swapPoint]="point"
      [identifierColor]="isDouble() ? 'blue' : null"
    ></app-swap-modal-driver-report-item>
  }

  @if (isDouble() && technicalPoints().at(1); as point) {
    <app-swap-modal-driver-report-item
      [swapPoint]="point"
      identifierColor="sea-green"
    ></app-swap-modal-driver-report-item>
  }
}
